import React from 'react';
import { styled } from '@miro-site/ui-styled-engine';
import { Section, Grid, GridItem, Box, Typography, ArrowToRight, Link } from '@miro-site/ui-core';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var ReadMoreCard = styled('div', {
  border: '1px solid',
  borderColor: '$gray-30',
  borderRadius: '$200',
  boxShadow: '$100',
  minWidth: '218px',
  marginRight: '$200',
  '@sm': {
    minWidth: '270px'
  },
  '@lg': {
    flex: '0 0 calc(25% - 16px)',
    minWidth: 'auto'
  },
  '> div': {
    height: '100%'
  },
  '.readmore-card': {
    '&-box': {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      padding: '$300',
      '@xl': {
        padding: '$400'
      }
    },
    '&-bottom-part': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      svg: {
        color: '$blue-60'
      }
    }
  },
  '&:hover': {
    cursor: 'pointer',
    boxShadow: '$50'
  }
});

var ReadMoreSection = function ReadMoreSection(props) {
  var _props$cards;

  return /*#__PURE__*/_jsxs(Section, {
    pageTopInset: "1200",
    children: [/*#__PURE__*/_jsx(Grid, {
      children: /*#__PURE__*/_jsx(GridItem, {
        columnStart: "1",
        columnEnd: {
          '@initial': -1,
          '@md': 6
        },
        children: /*#__PURE__*/_jsx(Typography, {
          tag: "h2",
          type: "heading",
          variant: "heading-3",
          offsetBottom: {
            '@initial': '600',
            '@xl': '800'
          },
          renderChildrenAsHTML: true,
          children: (props === null || props === void 0 ? void 0 : props.title) || ''
        })
      })
    }), /*#__PURE__*/_jsx(Grid, {
      children: /*#__PURE__*/_jsx(GridItem, {
        xs: 12,
        children: /*#__PURE__*/_jsx(Box, {
          css: {
            display: 'flex',
            overflowX: 'auto'
          },
          children: props === null || props === void 0 ? void 0 : (_props$cards = props.cards) === null || _props$cards === void 0 ? void 0 : _props$cards.map(function (card, index) {
            var _card$cta, _card$cta2, _card$cta3;

            return /*#__PURE__*/_jsx(ReadMoreCard, {
              css: {
                backgroundColor: card.bgColor || '$yellow-60'
              },
              children: /*#__PURE__*/_jsx(Box, {
                asChild: true,
                children: /*#__PURE__*/_jsxs("a", {
                  href: card === null || card === void 0 ? void 0 : (_card$cta = card.cta) === null || _card$cta === void 0 ? void 0 : _card$cta.href,
                  className: "readmore-card-box",
                  children: [/*#__PURE__*/_jsxs("div", {
                    className: "readmore-card-top-part",
                    children: [/*#__PURE__*/_jsx(Typography, {
                      offsetBottom: {
                        '@initial': 'stacking-100',
                        '@xl': 'stacking-200'
                      },
                      tag: "h4",
                      type: "heading",
                      variant: "sub-heading-1",
                      children: card.titleSmall
                    }), /*#__PURE__*/_jsx(Typography, {
                      offsetBottom: "stacking-400",
                      variant: "sub-heading-1",
                      children: card.title
                    })]
                  }), /*#__PURE__*/_jsxs("div", {
                    className: "readmore-card-bottom-part",
                    children: [/*#__PURE__*/_jsx(Link, {
                      href: card === null || card === void 0 ? void 0 : (_card$cta2 = card.cta) === null || _card$cta2 === void 0 ? void 0 : _card$cta2.href,
                      children: card === null || card === void 0 ? void 0 : (_card$cta3 = card.cta) === null || _card$cta3 === void 0 ? void 0 : _card$cta3.text
                    }), /*#__PURE__*/_jsx(ArrowToRight, {})]
                  })]
                })
              })
            }, 'readmore-' + index);
          })
        })
      })
    })]
  });
};

export default ReadMoreSection;